export const toAbs = (time?: number) => {
  if (time === undefined) return
  if (time < 24 * 60 * 60 * 1000) {
    // less than a day (or negative) -> relative time)
    return Date.now() + time
  }
  return time
}

/**
 * Get absolute time in format "12:34:56"
 */
export function absoluteTime({
  time,
  noTimezone = false,
}: {
  time: number
  noTimezone?: boolean
}) {
  if (typeof time !== 'number' || !isFinite(time) || time < 0) return ''
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
    ...(noTimezone && { timeZone: 'UTC' }),
  } as const
  const format = new Intl.DateTimeFormat('en-US', options)
  return format.format(new Date(time))
}

/**
 * Get absolute time in format "56"
 */
export function absoluteTimeSeconds({ time }: { time: number }) {
  if (typeof time !== 'number' || !isFinite(time) || time < 0) return ''
  const options = {
    second: 'numeric',
  } as const
  const format = new Intl.DateTimeFormat('en-US', options)
  return format.format(new Date(time))
}

export const EMPTY_TIME = '– –:– –:– –'

/**
 * Format a duration in whole seconds as "mm:ss".
 * e.g. 90 → "01:30", 30 → "00:30"
 */
export function formatCountdown(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds))
  const mm = String(Math.floor(s / 60)).padStart(2, '0')
  const ss = String(s % 60).padStart(2, '0')
  return `${mm}:${ss}`
}
